import * as React from 'react';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const lightBlue = '#C8EAFB';
const blue = '#0b2146';
const orange = '#f57153';
const yellow = '#ffd249';

const style = css`

	&.center {
		position: absolute;
		top: 20%;
		bottom: 0;
		left: 0;
		right: 0;
	}

    .loader {
        position: relative;
        margin: 0 auto;
        width: 72px;
        &:before {
            content: '';
            display: block;
            padding-top: 100%;
        }
    }

    .circular {
        animation: rotate 2s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }


    .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }

    @keyframes color {
        100%,
        0% {
            stroke: ${orange};
        }
        40% {
            stroke: ${yellow};
        }
        66% {
            stroke: ${blue};
        }
        80%,
        90% {
            stroke: ${lightBlue};
        }
    }


`;

export default props => (
    <div className={props.noCenter ? 'no-center' : 'center'} css={style}>
        <div className="loader">
            <svg className="circular" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="1" strokeMiterlimit="10"/>
            </svg>
        </div>
    </div>
);